import {
    GTM_SELECTOR_PRODUCT_CLICK,
    GTM_SELECTOR_PRODUCT_ID,
    GTM_SELECTOR_PRODUCT_TITLE,
} from './gtmSelectors';
import {gtmProductClick} from './gtmProductClick';

export const gtmProductsClickInit = (element, listName) => {
    const productLinks = element.querySelectorAll(GTM_SELECTOR_PRODUCT_CLICK);

    productLinks.forEach((link) => {
        const productCard = link.closest(GTM_SELECTOR_PRODUCT_ID);
        const title = productCard.querySelector(GTM_SELECTOR_PRODUCT_TITLE)?.innerText;

        link.addEventListener('auxclick', () => {
            gtmProductClick(productCard, title, listName);
        });

        link.addEventListener('click', () => {
            gtmProductClick(productCard, title, listName);
        });
    });
};
